import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, MapPin, Clock, Instagram } from 'lucide-react';
export function Contact() {
  return <section id="contacto" className="py-32 bg-brand-black relative" data-id="element-232" data-mp="35a9iq0pbufft">
      <div className="max-w-7xl mx-auto px-6" data-id="element-233" data-mp="3173hx8kzhggq">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16" data-id="element-234" data-mp="2w7qk5sskqozd">
          <h2 className="font-heading text-5xl md:text-6xl text-brand-white" data-id="element-235" data-mp="3oy8v1fzjhunc">
            <span className="text-brand-gold" data-id="element-236" data-mp="3k3uyha955hh3">Encontranos</span>
          </h2>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12" data-id="element-237" data-mp="3f5td2io8t62g">
          {/* Left - Info */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-6" data-id="element-238" data-mp="gh4dh935dpiv">
            <div className="bg-[#111] border border-brand-gold/30 p-6 rounded-xl flex items-start gap-4" data-id="element-239" data-mp="3ou61glni3kbf">
              <MessageCircle className="w-8 h-8 text-brand-gold shrink-0 mt-1" data-id="element-240" data-mp="3b2rey4udx0zm" />
              <div data-id="element-241" data-mp="3f3js396dnq16">
                <h3 className="text-brand-white font-bold text-lg mb-1" data-id="element-242" data-mp="3f31nnp9ka5i6">
                  WhatsApp
                </h3>
                <p className="text-brand-white/70 mb-4" data-id="element-243" data-mp="317g07miz7trv">+54 9 11 2706-3704</p>
                <a href="https://wa.me/5491127063704" target="_blank" rel="noopener noreferrer" className="inline-flex px-6 py-2 bg-brand-gold text-brand-black font-bold rounded hover:bg-brand-white transition-colors text-sm" data-id="element-244" data-mp="365hjo8kbdv3v">
                  Escribinos
                </a>
              </div>
            </div>

            <div className="bg-[#111] border border-brand-gold/30 p-6 rounded-xl flex items-start gap-4" data-id="element-245" data-mp="uduc2stxty6w">
              <MapPin className="w-8 h-8 text-brand-gold shrink-0 mt-1" data-id="element-246" data-mp="239hhvniuslud" />
              <div data-id="element-247" data-mp="1ybpm2if38fkw">
                <h3 className="text-brand-white font-bold text-lg mb-1" data-id="element-248" data-mp="1yeloaixyxqf5">
                  Dirección
                </h3>
                <p className="text-brand-white/70" data-id="element-249" data-mp="1pbswmekvjcos">
                  Los Patos 2927, Parque Patricios, CABA
                </p>
              </div>
            </div>

            <div className="bg-[#111] border border-brand-gold/30 p-6 rounded-xl flex items-start gap-4" data-id="element-250" data-mp="2m1aa3fq3m311">
              <Clock className="w-8 h-8 text-brand-gold shrink-0 mt-1" data-id="element-251" data-mp="2i19sxnbm7dqa" />
              <div data-id="element-252" data-mp="2d8grb8bg0lif">
                <h3 className="text-brand-white font-bold text-lg mb-1" data-id="element-253" data-mp="2d7xajuxj435z">
                  Horario
                </h3>
                <p className="text-brand-white/70" data-id="element-254" data-mp="288uc4tc20v6z">
                  Lunes a sábados de 9 a 19hs
                </p>
              </div>
            </div>

            <div className="bg-[#111] border border-brand-gold/30 p-6 rounded-xl flex items-start gap-4" data-id="element-255" data-mp="30ykj8if9qwtl">
              <Instagram className="w-8 h-8 text-brand-gold shrink-0 mt-1" data-id="element-256" data-mp="38c1vkvocfc46" />
              <div data-id="element-257" data-mp="3d8sdlojpkhs8">
                <h3 className="text-brand-white font-bold text-lg mb-1" data-id="element-258" data-mp="3da3qcdv4szvh">
                  Redes Sociales
                </h3>
                <div className="flex gap-4 mt-2" data-id="element-259" data-mp="3iarcal4i6qiu">
                  <a href="https://instagram.com/flash.go.arg" target="_blank" rel="noopener noreferrer" className="text-brand-white/70 hover:text-brand-gold transition-colors" data-id="element-260" data-mp="3mbbbrvcju685">
                    @flash.go.arg
                  </a>
                  <span className="text-brand-white/30" data-id="element-261" data-mp="4ujzflhxntjl">|</span>
                  <a href="https://tiktok.com/@flashgo.arg" target="_blank" rel="noopener noreferrer" className="text-brand-white/70 hover:text-brand-gold transition-colors" data-id="element-262" data-mp="9t4tf36ldgzl">
                    TikTok: @flashgo.arg
                  </a>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right - Map */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="h-[500px] rounded-xl overflow-hidden border border-brand-gold/30" data-id="element-263" data-mp="134syr53c18x">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3282.805820461877!2d-58.40388102340813!3d-34.63433606044738!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bccb17130f1465%3A0x6395b281b3726c04!2sLos%20Patos%202927%2C%20C1437%20Cdad.%20Aut%C3%B3noma%20de%20Buenos%20Aires!5e0!3m2!1sen!2sar!4v1717684000000!5m2!1sen!2sar" width="100%" height="100%" style={{
            border: 0,
            filter: 'invert(90%) hue-rotate(180deg) contrast(100%)'
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-264" data-mp="3ed2idus8zutp"></iframe>
          </motion.div>
        </div>
      </div>
    </section>;
}